<div *ngIf="bannerVisible | async" class="announcement-banner-wrapper">
    <div class="fa fa-times navbar-form-close announcement-banner-close-button" (click)="closeAnnouncementBanner()"></div>
    <h4 class="announcement-banner-title">{{'UPDATE_NOTIFICATION_TITLE' | translate}}</h4>
    <p>{{'UPDATE_NOTIFICATION_TEXT' | translate}}</p>
    
    <div class="announcement-banner-footer">
        <p>
            <a class="btn btn-link" href="{{ 'UPDATE_NOTIFICATION_ACTION_LINK' | translate }}" target="_blank">
                {{ 'UPDATE_NOTIFICATION_ACTION_TEXT' | translate }}
            </a>
        </p>
    </div>
</div>